import ClickPinController from '../ui/ClickPinController';

export default class PinGroupManager {
  constructor(camera, globe, userPin, domElement) {
    this._groupPins = null;
    this._shownPins = [];
    this.onPinClicked = null;
    this.onUserPinClicked = null;
    this._clickPinController = new ClickPinController(camera, globe, userPin, domElement);
    this._clickPinController.onPinClicked = (pin, pinID, groupID) => {
      if (this.onPinClicked) this.onPinClicked(pin);
      this._globe.highlightPin(pinID, groupID);
    };
    this._clickPinController.onUserPinClicked = () => {
      if (this.onUserPinClicked) this.onUserPinClicked();
    };
    this._globe = globe;
  }

  get groupPins() {
    return this._groupPins;
  }

  set groupPins(value) {
    this._groupPins = value;
    this._shownPins = [];
    this._clickPinController.setPins(null);
  }

  startInteraction() {
    this._clickPinController.startInteraction();
  }

  stopInteraction() {
    this._clickPinController.stopInteraction();
  }

  updateShownPins(showDetails, lat, long, onLabelsRequested) {
    // can't be different
    if (showDetails === this._showDetails && this._lat === lat && this._long === long) return;

    this._showDetails = showDetails;
    this._lat = lat;
    this._long = long;
    const groupPins = this._groupPins;
    const shown = [];
    let closest = null;
    let minDist = Number.POSITIVE_INFINITY;
    const radius = 20;
    const radSqr = radius * radius;
    // console.log('long before ' + Math.floor(long));
    // this locks the range of longitude from -180 to 180. Outside of this range pins were not found
    if (long > 0) {
      long %= 360;
      if (long > 180) {
        long -= 360;
      }
    } else if (long < 0) {
      long %= -360;
      if (long < -180) {
        long += 360;
      }
    }
    // console.log('long after ' + Math.floor(long));
    let groupID = -1;

    if (showDetails) {
      if (groupPins) {
        const len = groupPins.length;
        for (let i = 0; i < len; ++i) {
          const group = groupPins[i];
          let dx = group.location.lat - lat;
          const dy = group.location.long - long;
          if (dx > 180) dx -= 360;
          else if (dx < -180) dx += 360;
          const dist = dx * dx + dy * dy;
          if (dist < radSqr) {
            shown.push(i);
          }
          if (dist < minDist) {
            minDist = dist;
            closest = group.pins;
            groupID = i;
          }
        }
      }
    }

    // show labels for the closest pin group
    if (closest !== this._closestPins) {
      this._closestPins = closest;

      if (groupID > 0) {
        this._globe.showLabels();
        if (onLabelsRequested) onLabelsRequested(groupID);
      } else {
        this._globe.hideLabels();
      }
    }

    // check if our set changed
    if (!this.arrayEquals(this._shownPins, shown)) {
      this._globe.setDetailPins(shown, groupPins);
      this._clickPinController.setPins(shown, groupPins);
    }

    this._shownPins = shown;
  }

  arrayEquals(a, b) {
    // compare lengths - can save a lot of time
    if (a.length !== b.length) return false;

    for (let i = 0, l = a.length; i < l; i++) {
      // Check if we have nested arrays
      if (a[i] !== b[i]) {
        // Warning - two different object instances will never be equal: {x:20} != {x:20}
        return false;
      }
    }
    return true;
  }
}
